const patterns = {
  getBandIndex: (bullIndex, bearIndex) => {
    const bullBands = [],
      bearBands = []
    let firstIndex, lastIndex

    if (bullIndex.length > 1) {
      firstIndex = bullIndex[0]

      bullIndex.forEach((x, i) => {
        if (lastIndex && x - 1 !== lastIndex) {
          bullBands.push([firstIndex, lastIndex])
          firstIndex = x
        }

        lastIndex = bullIndex[i]
      })

      if (firstIndex <= lastIndex) {
        bullBands.push([firstIndex, lastIndex])
      }
    }

    lastIndex = undefined

    if (bearIndex.length > 1) {
      firstIndex = bearIndex[0]

      bearIndex.forEach((x, i) => {
        if (lastIndex && x - 1 !== lastIndex) {
          bearBands.push([firstIndex, lastIndex])
          firstIndex = x
        }

        lastIndex = bearIndex[i]
      })

      if (firstIndex <= lastIndex) {
        bearBands.push([firstIndex, lastIndex])
      }
    }

    return [bullBands, bearBands]
  },
  getPlotBands: (bullIndex, bearIndex, bullColor, bearColor, bullKey) => {
    const plotBands = []
    const [bullBands, bearBands] = patterns.getBandIndex(bullIndex, bearIndex)

    bullBands.forEach((bullBand) => {
      const adjust = 0.5

      plotBands.push({
        id: `${bullKey || 'bull'}-pattern-${bullBand[0]}`,
        color: bullColor,
        from: bullBand[0] - adjust,
        to: bullBand[1] + adjust,
      })
    })

    bearBands.forEach((bearBand) => {
      const adjust = 0.5

      plotBands.push({
        id: `bear-pattern-${bearBand[0]}`,
        color: bearColor,
        from: bearBand[0] - adjust,
        to: bearBand[1] + adjust,
      })
    })

    return plotBands
  },
  isRankedByFluctuatingGapInLast20Days: function (_rank, _last21Candles) {
    const last21Candles = [..._last21Candles]
    let last = last21Candles.shift()
    const standardGap = Math.abs(
      last21Candles[last21Candles.length - 1][3] -
        last21Candles[last21Candles.length - 2][3]
    )
    let rank = 1

    last21Candles.forEach((candle) => {
      const lastTradePrice = last[3]
      const currentTradePrice = candle[3]
      const gap = Math.abs(currentTradePrice - lastTradePrice)

      gap > standardGap && rank++
      last = candle
    })

    return rank <= _rank
  },
}

export default patterns
